var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g3, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountCreated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 165,
    viewBox: "0 0 192 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5932 25.8094C38.1797 25.2955 39.0477 23.5972 38.5321 22.016C38.0164 20.4349 36.3124 19.5697 34.726 20.0836C33.1396 20.5976 32.2715 22.2959 32.7871 23.8771C33.3028 25.4582 35.0068 26.3233 36.5932 25.8094Z",
    fill: "#2A2E37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1869 15.9869C44.2656 15.6374 44.8559 14.4825 44.5053 13.4073C44.1547 12.3322 42.9959 11.7439 41.9171 12.0933C40.8384 12.4428 40.2481 13.5977 40.5987 14.6728C40.9494 15.748 42.1081 16.3363 43.1869 15.9869Z",
    fill: "#2A2E37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0576 130C129.195 130 156.058 103.138 156.058 70.0005C156.058 36.8634 129.195 10.0005 96.0576 10.0005C62.9205 10.0005 36.0576 36.8634 36.0576 70.0005C36.0576 103.138 62.9205 130 96.0576 130Z",
    fill: "#1C2538"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2994_30759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5819 14.6832V94.2476C94.5819 96.0288 93.1322 97.4709 91.3414 97.4709H25.5931C23.8022 97.4709 22.3525 96.0288 22.3525 94.2476V14.6832C22.3525 12.902 23.8022 11.46 25.5931 11.46H91.3414C93.1322 11.46 94.5819 12.902 94.5819 14.6832Z",
    fill: "#5C6479"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5819 14.6235V22.1162H22.3525V14.6235C22.3525 12.8752 23.8022 11.46 25.5931 11.46H91.3414C93.1322 11.46 94.5819 12.8752 94.5819 14.6235Z",
    fill: "#474E61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1299 18.6908C28.0797 18.6908 28.8496 17.9241 28.8496 16.9782C28.8496 16.0324 28.0797 15.2656 27.1299 15.2656C26.1801 15.2656 25.4102 16.0324 25.4102 16.9782C25.4102 17.9241 26.1801 18.6908 27.1299 18.6908Z",
    fill: "#777E8E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4795 18.6908C33.4293 18.6908 34.1993 17.9241 34.1993 16.9782C34.1993 16.0324 33.4293 15.2656 32.4795 15.2656C31.5297 15.2656 30.7598 16.0324 30.7598 16.9782C30.7598 17.9241 31.5297 18.6908 32.4795 18.6908Z",
    fill: "#777E8E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8301 18.6908C38.7799 18.6908 39.5498 17.9241 39.5498 16.9782C39.5498 16.0324 38.7799 15.2656 37.8301 15.2656C36.8803 15.2656 36.1104 16.0324 36.1104 16.9782C36.1104 17.9241 36.8803 18.6908 37.8301 18.6908Z",
    fill: "#777E8E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M85.654 81.1077H77.8263C77.0605 81.1077 76.3799 80.5146 76.3799 79.6673V38.2344C76.3799 37.4718 76.9755 36.7939 77.8263 36.7939H85.654C86.4197 36.7939 87.1004 37.3871 87.1004 38.2344V79.6673C87.1004 80.4299 86.5048 81.1077 85.654 81.1077Z",
    fill: "#434A5B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M85.654 81.1084H77.8263C77.0605 81.1084 76.3799 80.5152 76.3799 79.6679V53.1474C76.3799 52.3849 76.9755 51.707 77.8263 51.707H85.654C86.4197 51.707 87.1004 52.3001 87.1004 53.1474V79.6679C87.1004 80.4305 86.5048 81.1084 85.654 81.1084Z",
    fill: "#8A91A3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0836 81.1077H62.256C61.4902 81.1077 60.8096 80.5146 60.8096 79.6673V38.2344C60.8096 37.4718 61.4052 36.7939 62.256 36.7939H70.0836C70.8494 36.7939 71.5301 37.3871 71.5301 38.2344V79.6673C71.5301 80.4299 70.8494 81.1077 70.0836 81.1077Z",
    fill: "#434A5C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0836 81.1074H62.256C61.4902 81.1074 60.8096 80.5142 60.8096 79.6669V64.2461C60.8096 63.4835 61.4052 62.8057 62.256 62.8057H70.0836C70.8494 62.8057 71.5301 63.3988 71.5301 64.2461V79.6669C71.5301 80.4295 70.8494 81.1074 70.0836 81.1074Z",
    fill: "#939BAE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5133 81.1077H46.6857C45.9199 81.1077 45.2393 80.5146 45.2393 79.6673V38.2344C45.2393 37.4718 45.8348 36.7939 46.6857 36.7939H54.5133C55.2791 36.7939 55.9598 37.3871 55.9598 38.2344V79.6673C55.8747 80.4299 55.2791 81.1077 54.5133 81.1077Z",
    fill: "#434A5C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5133 81.107H46.6857C45.9199 81.107 45.2393 80.5139 45.2393 79.6666V47.6387C45.2393 46.8761 45.8348 46.1982 46.6857 46.1982H54.5133C55.2791 46.1982 55.9598 46.7914 55.9598 47.6387V79.6666C55.8747 80.4292 55.2791 81.107 54.5133 81.107Z",
    fill: "#939BAE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8581 81.1077H31.0304C30.2647 81.1077 29.584 80.5146 29.584 79.6673V38.2344C29.584 37.4718 30.1796 36.7939 31.0304 36.7939H38.8581C39.6238 36.7939 40.3045 37.3871 40.3045 38.2344V79.6673C40.3045 80.4299 39.6238 81.1077 38.8581 81.1077Z",
    fill: "#434A5C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8581 81.1082H31.0304C30.2647 81.1082 29.584 80.5151 29.584 79.6678V65.2637C29.584 64.5011 30.1796 63.8232 31.0304 63.8232H38.8581C39.6238 63.8232 40.3045 64.4164 40.3045 65.2637V79.6678C40.3045 80.4303 39.6238 81.1082 38.8581 81.1082Z",
    fill: "#939BAE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2994_30759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.747 55.72V128.947C169.747 130.587 168.42 131.914 166.78 131.914H106.598C104.959 131.914 103.632 130.587 103.632 128.947V55.72C103.632 54.0806 104.959 52.7534 106.598 52.7534H166.78C168.42 52.7534 169.747 54.0806 169.747 55.72Z",
    fill: "#5C6479"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M159.892 94.6167H123.938V101.171H159.892V94.6167Z",
    fill: "#707992",
    stroke: "#4C5468",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 101.159H114.715V122.006H123.76V101.159Z",
    fill: "#AAB2C5",
    stroke: "#4C5468",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M159.88 94.6167H123.76V122.018H159.88V94.6167Z",
    fill: "#707992",
    stroke: "#4C5468",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M150.978 122.006H114.715V101.159H159.892",
    stroke: "#4C5468",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M159.892 108.306H114.715",
    stroke: "#4C5468",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M159.892 115.156H114.715",
    stroke: "#4C5468",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M132.877 94.6167V122.007",
    stroke: "#4C5468",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M141.897 94.6167V122.007",
    stroke: "#4C5468",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.919 94.6167V122.007",
    stroke: "#4C5468",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.051 70.5427C159.681 71.3983 159.504 72.6065 158.654 73.2415L144.515 83.8056C143.849 84.3032 142.94 84.313 142.264 83.8299L137.39 80.3491L128.613 85.8866C127.998 86.2742 127.219 86.2795 126.6 85.9003L123.95 84.2781L117.624 88.1325C116.718 88.6842 115.54 88.3925 114.992 87.4811C114.444 86.5696 114.734 85.3835 115.639 84.8318L122.96 80.3714C123.571 79.999 124.337 79.9998 124.947 80.3735L127.58 81.9849L136.438 76.3963C137.094 75.9824 137.933 76.0065 138.565 76.4575L143.347 79.8731L156.37 70.1433C157.22 69.5084 158.42 69.6872 159.051 70.5427Z",
    fill: "#AAB2C5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M169.747 55.691V62.6485H103.632V55.691C103.632 54.0676 104.959 52.7534 106.598 52.7534H166.78C168.42 52.7534 169.747 54.0676 169.747 55.691Z",
    fill: "#474E61"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2994_30759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.877 32.3506V111.563C132.877 113.336 131.427 114.772 129.636 114.772H63.888C62.0972 114.772 60.6475 113.336 60.6475 111.563V32.3506C60.6475 30.5772 62.0972 29.1416 63.888 29.1416H129.636C131.427 29.1416 132.877 30.5772 132.877 32.3506Z",
    fill: "#5C6479"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M132.877 32.3052V39.7978H60.6475V32.3052C60.6475 30.5569 62.0972 29.1416 63.888 29.1416H129.636C131.427 29.1416 132.877 30.5569 132.877 32.3052Z",
    fill: "#474E61"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4248 36.3725C66.3746 36.3725 67.1446 35.6057 67.1446 34.6599C67.1446 33.714 66.3746 32.9473 65.4248 32.9473C64.475 32.9473 63.7051 33.714 63.7051 34.6599C63.7051 35.6057 64.475 36.3725 65.4248 36.3725Z",
    fill: "#777E8E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7744 36.3725C71.7242 36.3725 72.4942 35.6057 72.4942 34.6599C72.4942 33.714 71.7242 32.9473 70.7744 32.9473C69.8246 32.9473 69.0547 33.714 69.0547 34.6599C69.0547 35.6057 69.8246 36.3725 70.7744 36.3725Z",
    fill: "#777E8E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.125 36.3725C77.0748 36.3725 77.8448 35.6057 77.8448 34.6599C77.8448 33.714 77.0748 32.9473 76.125 32.9473C75.1752 32.9473 74.4053 33.714 74.4053 34.6599C74.4053 35.6057 75.1752 36.3725 76.125 36.3725Z",
    fill: "#777E8E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M106.648 74.8158L103.16 73.1212C101.628 74.9005 99.331 76.002 96.8636 76.002C92.2691 76.002 88.5254 72.2739 88.5254 67.6985C88.5254 67.1054 88.6105 66.597 88.6956 66.0039L85.2072 64.3093L77.7199 60.6659C76.869 63.0383 76.3585 65.665 76.5287 68.4611C76.9541 79.0523 85.6326 87.6101 96.1829 87.949C103.755 88.2032 110.477 84.3056 114.136 78.4592L106.648 74.8158ZM96.7785 47.3633C89.4614 47.3633 82.995 51.1761 79.4215 57.0225L86.9089 60.6659L90.3973 62.3605C91.7586 60.8354 93.6304 59.7339 95.7575 59.4797L96.268 55.6668L97.289 47.448C97.1189 47.3633 96.9487 47.3633 96.7785 47.3633ZM101.373 47.8717L100.352 56.0905L99.8415 59.9033C102.905 61.0896 105.117 64.1398 105.117 67.6138C105.117 68.2069 105.032 68.8 104.947 69.3084L108.435 71.003L115.922 74.6464C116.773 72.4434 117.199 70.0709 117.199 67.6138V67.529C117.113 58.0393 110.392 49.9899 101.373 47.8717Z",
    fill: "#AAB2C5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7779 47.3633C89.4607 47.3633 82.9944 51.1761 79.4209 57.0225L86.9082 60.6659L90.3966 62.3605C91.758 60.8354 93.6298 59.7339 95.7569 59.4797L96.2674 55.6668L97.2884 47.448C97.1182 47.3633 96.9481 47.3633 96.7779 47.3633Z",
    fill: "#AAB2C5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M101.373 47.8721L100.352 56.0909L99.8418 59.9037C102.905 61.09 105.117 64.1402 105.117 67.6142C105.117 68.2073 105.032 68.8004 104.947 69.3088L108.435 71.0034L115.923 74.6468C116.773 72.4438 117.199 70.0713 117.199 67.6142V67.5294C117.114 58.0397 110.392 49.9903 101.373 47.8721Z",
    fill: "#474E61"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M90.3976 62.3607L86.9092 60.6661C89.0363 57.7852 92.3545 55.8365 96.1833 55.667L95.6728 59.4798C93.6308 59.734 91.7589 60.7508 90.3976 62.3607Z",
    fill: "#6076AB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M103.159 73.1205L106.648 74.8151C104.436 77.8654 100.862 79.8142 96.7782 79.8142C90.0567 79.8142 84.6113 74.3915 84.6113 67.6978C84.6113 66.5116 84.7815 65.4101 85.1218 64.3086L88.6102 66.0032C88.5252 66.5116 88.4401 67.1047 88.4401 67.6978C88.4401 72.2732 92.1837 76.0013 96.7782 76.0013C99.3307 76.0013 101.628 74.8999 103.159 73.1205Z",
    fill: "#6076AB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M108.946 67.6981C108.946 68.8843 108.776 70.0705 108.435 71.0873L104.947 69.3927C105.032 68.7996 105.117 68.2912 105.117 67.6981C105.117 64.2242 102.905 61.1739 99.8418 59.9877L100.352 56.1748C105.287 57.6152 108.946 62.2754 108.946 67.6981Z",
    fill: "#6076AB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M115.496 94.2197H76.8825C75.9367 94.2197 75.1699 94.9865 75.1699 95.9323C75.1699 96.8782 75.9367 97.6449 76.8825 97.6449H115.496C116.441 97.6449 117.208 96.8782 117.208 95.9323C117.208 94.9865 116.441 94.2197 115.496 94.2197Z",
    fill: "#939BAE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0943 102.593H76.8825C75.9367 102.593 75.1699 103.36 75.1699 104.305C75.1699 105.251 75.9367 106.018 76.8825 106.018H94.0943C95.0401 106.018 95.8069 105.251 95.8069 104.305C95.8069 103.36 95.0401 102.593 94.0943 102.593Z",
    fill: "#939BAE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2994_30759",
    x: 0.352539,
    y: 0.459961,
    width: 116.229,
    height: 130.011,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2994_30759"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2994_30759",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2994_30759",
    x: 81.6318,
    y: 41.7534,
    width: 110.114,
    height: 123.161,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2994_30759"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2994_30759",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2994_30759",
    x: 38.6475,
    y: 18.1416,
    width: 116.229,
    height: 129.63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2994_30759"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2994_30759",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCreated);
export default __webpack_public_path__ + "static/media/account-created.f9b67dc25394bcfbb7f06996e79ac9b1.svg";
export { ForwardRef as ReactComponent };